import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import Env from 'root/lib/Env';
import { showLoadingPercentage } from 'root/lib/utilityFunctions';
import GlobalStyle from '../GlobalStyle';
import StandardPopup from './StandardPopup';

const isUASupported =
    Env.isDeviceSupported || localStorage.getItem('ignoreUnsupported') === 'true';

const Link = styled.a`
  font-family: Quicksand;
  font-size: 34px;
  font-weight: bold;
  color: #214ed0;
  line-height: 39px;
`;

const Container = styled(StandardPopup)`
  position: fixed;
`;

/**
 * Unsupported displays a message to the user that the device and/or browser
 * they are using is not supported by Boost Reading.
 * Unsupported will display its children if the device and browser meet the
 * requirements of Boost Reading. Otherwise, they are not rendered at all.
 */
const Unsupported = (props) => {
  const [isSupported, setIsSupported] = useState(isUASupported);

  const proceedAnyway = () => {
    // hide app display to show loading screen
    showLoadingPercentage();
    localStorage.setItem('ignoreUnsupported', true);
    setIsSupported(true);
  };

  useEffect(() => {
    if (!isSupported) {
      // hide loading screen
      window.reactLoaded();
    }
  });

  return !isSupported ? (
    <>
      <GlobalStyle />
      <Container
        header=""
        message="You may continue, but your experience may not be optimal."
        buttonTitle="Continue"
        customCallback={proceedAnyway}
        actionScope="error-unsupported"
      >
        {'Your browser or device doesn\'t meet our '}
        <Link
          href="https://www.amplify.com/customer-requirements/"
          target="_blank"
          data-dd-action-name="error-unsupported:requirements"
        >
          requirements
        </Link>
        .
      </Container>
    </>
  ) : (
    props.children || null
  );
};

Unsupported.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

export default Unsupported;
